module.exports = __webpack_public_path__ + "img/ic_drop.5a607ae3.svg";